export default __webpack_public_path__ + "static/media/materialdesignicons-webfont.b994f21c.ttf";